import React from "react";

import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import SilentlyBannedUsersData from "./silently-banned-users-data";
import SilentlyBannedUsersForm from "./silently-banned-users-form";

const SilentlyBannedUsers = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SILENTLY_BANNED_USERS",
      "SILENTLY_BANNED_USERS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("SILENTLY_BANNED_USERS")}
        subTitle={i18n.get("ADVANCED_MODE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <SilentlyBannedUsersForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <SilentlyBannedUsersData />
    </ET3PageDiv>
  );
});
export default SilentlyBannedUsers;
